
// src/reducers/media-query.js

import { reducer } from 'redux-mediaquery'
export default reducer



// WEBPACK FOOTER //
// ./src/reducers/media-query.js